import { render, staticRenderFns } from "./cooperateTreasure.vue?vue&type=template&id=3a26d4ba&"
import script from "./cooperateTreasure.vue?vue&type=script&lang=js&"
export * from "./cooperateTreasure.vue?vue&type=script&lang=js&"
import style0 from "./cooperateTreasure.vue?vue&type=style&index=0&id=3a26d4ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports